// extracted by mini-css-extract-plugin
export default {"cta":"KG-z","disabled":"LG-z"};